import { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import {Table, Input, Button, Modal, ModalHeader, ModalBody} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';

import { translations } from './../../i18/translations.js';
import Pager from './../../util/Pager.js';
import Search from './../../util/Search.js';
import { Space } from './../../util/Html.js';
import './Log.css';

const LogNewsLetter = () => {
    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const {user, lang, checkAccess} = useOutletContext();

    const [rows, setRows] = useState([]);
    const [pager, setPager] = useState([]);
    const [query, setQuery] = useState("");
    const [orderBy, setOrderBy] = useState(0);
    const [selectedMember, setSelectedMember] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [pageIndex, setPageIndex] = useState(0);
    const [template, setTemplate] = useState('');

    const pageSize = 20;

    useEffect(() => {
        fetchLogs(pageIndex, query, orderBy);
    }, [pageIndex, query, orderBy, user]);

    const fetchLogs = async (pageIndex, queryString, orderBy) => {
        try {
            const payload = {
                filter: {
                    pageSize: 20,
                    pageIndex: pageIndex,
                    queryString: queryString,
                    orderBy: orderBy
                }
            };

            const response = await fetch(`${API_URL}/admin/get_log_newsletter_list.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                setRows(data.data);
                setPager(data.pagerButtonIndexes);
                setTemplate(data.template);
            }
        } catch (error) {
            console.error("Error fetching log rows:", error);
        }
    };

    const handleSearch = (query) => {
        setQuery(query);
        setPageIndex(0);
    };

    const handleOrderBy = (orderById) => {
        var newOrderBy = orderBy === orderById ? orderById + 1 : (orderBy === orderById + 1 ? 0 : orderById);
        setOrderBy(newOrderBy);
    };

    const getOrderByArrow = (orderById) => {
        return orderBy === orderById ? <FontAwesomeIcon icon={faSortDown} /> : (orderBy === orderById + 1 ? <FontAwesomeIcon icon={faSortUp} /> : <FontAwesomeIcon icon={faSort} />)
    };

    return (
            <div className="container mt-4">
            
                <Search placeholder={translations[lang].log_newsletter_data} handleSearch={handleSearch} />
            
                <Table striped className="mbkegy-table">
                    <thead>
                        <tr>                        
                            <th style={{width: '10%'}}>
                                <a href="#" onClick={() => handleOrderBy(1)}>{getOrderByArrow(1)}{translations[lang].col_send_batch_id}</a>
                            </th>
                            <th style={{width: '15%'}}>
                                <a href="#" onClick={() => handleOrderBy(3)}>{getOrderByArrow(3)}{translations[lang].col_newsletter_name}</a>
                            </th>
                            <th style={{width: '20%'}}>
                                <a href="#" onClick={() => handleOrderBy(5)}>{getOrderByArrow(5)}{translations[lang].col_fullname}</a>
                            </th>
                            <th style={{width: '25%'}}>
                                <a href="#" onClick={() => handleOrderBy(7)}>{getOrderByArrow(7)}{translations[lang].col_email}</a>
                            </th>
                            <th style={{width: '15%'}}>
                                <a href="#" onClick={() => handleOrderBy(9)}>{getOrderByArrow(9)}{translations[lang].col_error}</a>
                            </th>
                            <th style={{width: '15%'}}>
                                <a href="#" onClick={() => handleOrderBy(11)}>{getOrderByArrow(11)}{translations[lang].col_date}</a>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                                <tr key={row.id}>
                                    <td>{row.send_batch_id ? row.send_batch_id : <Space />}</td>
                            <td>{row.newsletter_name}</td>
                            <td>{row.fullname}</td>
                            <td>{row.email}</td>
                            <td>{row.error}</td>
                            <td>{row.crd}</td>
                            </tr>
                                    ))}
                    </tbody>
                </Table>
            
                <Pager template={`${translations[lang].rows}: ${template}`} pager={pager} handlePageChange={setPageIndex} />
            
            </div>
            );
};

export default LogNewsLetter;
